import invert from 'lodash/invert'
import * as channelTypes from './types'

export const roles = {
  READER: 'reader',
  WRITER: 'writer',
  ADMIN: 'admin',
}
export const invertRoles = invert(roles)

export const rolesForSelect = Object.keys(roles).map(roleLabel => ({
  value: roles[roleLabel],
  label: roleLabel,
}))

export const defaultPublicRole = roles.WRITER
export const defaultPrivateRole = roles.WRITER
export const defaultPersonalRole = roles.ADMIN

export const canWriteInChannel = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('write'))

export const canAccessChannel = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('read'))

export const canEditNote = ({ channel, note }) => {
  return Boolean(canWriteInChannel({ channel }) && !note.archivedAt)
}

export const canManageChannel = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('manage'))

export const canManageChannelOrganizationalSettings = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('write'))

export const canCreateNote = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('write'))

export const canManageNote = ({ channel }) =>
  Boolean(channel && channel.permissions && channel.permissions.get('write'))

export const canMoveNote = ({ channel, note }) =>
  Boolean(canWriteInChannel({ channel }) && !note.archivedAt)

export function getDefaultUserRole(type) {
  switch (type) {
    case channelTypes.PRIVATE:
      return defaultPrivateRole
    case channelTypes.PUBLIC:
      return defaultPublicRole
    case channelTypes.PERSONAL:
      return defaultPersonalRole
    default:
      return 'no_type'
  }
}

export const rolesMap = {
  [roles.READER]: {
    title: 'Reader',
    description: 'Can only read docs in this channel',
  },
  [roles.WRITER]: {
    title: 'Writer',
    description: 'Can read and write in this channel',
  },
  [roles.ADMIN]: {
    title: 'Admin',
    description: 'Can read, write and manage in this channel',
  },
}

export const rolesMapPluralized = {
  [roles.READER]: {
    title: 'Readers',
    description: 'Can only read docs in this channel',
  },
  [roles.WRITER]: {
    title: 'Writers',
    description: 'Can read and write in this channel',
  },
  [roles.ADMIN]: {
    title: 'Admins',
    description: 'Can read, write and manage in this channel',
  },
}

export const defaultRolesMapFree = {
  [roles.READER]: {
    title: 'Readers',
    description: 'Upgrade to set default reader roles',
    disabled: true,
  },
  [roles.WRITER]: {
    title: 'Writers',
    description: 'Can read and write in this channel',
  },
}

export const defaultRolesMapPaid = {
  [roles.READER]: {
    title: 'Readers',
    description: 'Can only read docs in this channel',
  },
  [roles.WRITER]: {
    title: 'Writers',
    description: 'Can read and write in this channel',
  },
}
